function getSigFitRequestOutput (variantSetId, sigFitRequestId) {
  if (!this.variantSets) return
  const variantSet = this.variantSets[variantSetId]
  if (!variantSet) return
  const { sigFitRequests } = variantSet
  return sigFitRequests.find(({ id }) => id === sigFitRequestId)
}

export default getSigFitRequestOutput